import { FileWithPath } from "@mantine/dropzone";
import { useNavigate } from "react-router-dom";

import { getPartsFromFiles } from "#modules/parts/domain/getPartsFromFiles";
import { CreatePartResponse } from "#modules/parts/infra/createPart.api";
import { useCreatePart } from "#modules/parts/view/useCreatePart";
import { ROUTES } from "#shared/routes";
import { PartTypeType } from "shared";

type Options = {
  onSuccess?: (createdPart: CreatePartResponse | null) => void;
};

const MAX_FILE_SIZE_FOR_GRAPHS = 5 * 1024 * 1024;

export const useCreatePartToSearch = (options?: Options) => {
  const navigate = useNavigate();
  const { createPart, isPending, progress, resetProgress } = useCreatePart({
    onSuccess: (createdPart) => {
      if (!createdPart) {
        return null;
      }

      options?.onSuccess?.(createdPart);
      navigate(ROUTES.partnerIaSimilarPart(createdPart.id));
    },
  });

  const uploadFile = async (files: FileWithPath[], type?: PartTypeType) => {
    if (!files.length) {
      return;
    }

    const parts = await getPartsFromFiles(files);

    await Promise.all(
      parts.map((part) => {
        const isLargeFile =
          !part.files[0]?.data.size || part.files[0].data.size > MAX_FILE_SIZE_FOR_GRAPHS;

        return createPart({
          data: {
            ...part,
            assemblySplitMode: "ALL",
            type,
            computeEmbeddings: false,
            computeGraphs: !isLargeFile,
            computeFeatures: !isLargeFile,
            computeTopologicalEmbedding: true,
          },
        });
      }),
    );
  };

  return { isPending, progress, uploadFile, resetProgress };
};
